import { targetable } from '@github/catalyst/lib/targetable'

export default targetable(class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', this.openModal)
  }

  disconnectedCallback () {
    this.removeEventListener('click', this.openModal)
  }

  openModal = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const modal = document.getElementById('subscription_gate_modal')
    if (modal) {
      modal.showModal()
    }
  }
})
